export default "__VITE_ASSET__DXhoM5PU__"